import React from 'react';
import RiskPage from '@/app/pages/risk-detail';
import AuditorContextProvider from '../components/AuditorContextProvider';
import { useNavigate } from 'react-router-dom';

/**
 * Auditor Risk Detail component
 * 
 * Renders a read-only version of the Risk Detail page for auditor view
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorRiskDetail: React.FC = () => {
  const navigate = useNavigate();

  // Create a navigation handler for back button
  const handleBackNavigation = () => {
    // Always navigate to auditor risk register
    navigate('/auditor-view/risk-register');
  };

  return (
    <AuditorContextProvider>
      {/* Pass the custom back navigation handler to risk page */}
      <RiskPage 
        isReadOnly={true}
        onBackNavigation={handleBackNavigation} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorRiskDetail;